import styled from "styled-components";

export const Container = styled.section`
    width: 100%;
    color: #58626c;
    padding: 0 6rem;

    div.top {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        h1 {
            font-family: 'Great Vibes', sans-serif;
            font-size: 4rem;
            text-align: center;
            font-weight: 200;
        }
        p {
            margin: 20px 0 10px;
            max-width: 500px;
            text-align: center;
        }

        @media (max-width: 500px) {
            h1 {
                font-size: 3rem;
            }
        }
    }

    @media (max-width: 870px) {
        padding: 0 3rem;
    }

    @media (max-width: 1000px) {
        padding: 0 1rem;
    }

    div.couple {
        display: flex;
        width: 100%;
        margin: 70px 0px 30px;
        max-height: 400px;

        div.img {
            img {
                object-fit: cover;
                height: 387px;
                width: 434px;
                border-radius: 10px;
                box-shadow: 0 0 10px 1px rgb(0 0 0 / 75%);
                object-position: top left;
            }
            
            /* img.welltonImg {
                object-position: top left;
            } */
            @media (max-width: 1000px) {
                img {
                    height: 287px;
                    width: 334px;
                }
            }            
            @media (max-width: 768px) {
                img {
                    height: 200px;
                    width: auto;
                }
            }            
            @media (max-width: 500px) {
                img {
                    height: auto;
                    width: 150px;
                }
            }            
            @media (max-width: 320px) {
                img {
                    display: none;
                }
            }            
        }

        div.history {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 100%;
            margin: 0 50px;
            text-align: center;
            overflow-y: scroll;
            overflow-x: hidden;

            ::-webkit-scrollbar {
                width: 2px;
            }

            ::-webkit-scrollbar-track {
                background-color: var(--background);
            }

            ::-webkit-scrollbar-thumb {
                background-color: #87868b;
                border-radius: 20px;
            }
            
            ::-webkit-scrollbar-thumb:hover {
                background-color: #696969;
            }

            h2 {
                font-family: 'Great Vibes', sans-serif;
                font-size: 2.5rem;
                font-weight: 200;
            }
            h3 {
                margin-bottom: 10px;
                font-family: 'Josefin Slab', sans-serif;
                font-weight: 200;
                font-size: 1.5rem;
            }

            div.scroll {
                width: 35px;
            }

            img.scrollRight {
                width: 100%;
                opacity: 0.5;
                margin-right: -23px;
            }
            img.scrollLeft {
                width: 100%;
                opacity: 0.5;
                margin-left: 14px;
            }

            p {
                font-size: 16px;
            }

            @media (min-width: 768px) {
                div.scroll {
                    display: none;
                }
            }

            @media (max-width: 700px) {
                p {
                    font-size: 12px;
                }
            }

            @media (max-width: 600px) {
                h2 {
                    margin-top: 3px;
                }
            }
        }

        @media (max-width: 1000px) {
            max-height: 300px;
        }

        @media (max-width: 768px) {
            max-height: 200px;
            div.history {
                margin: 0 10px;
            
                h2 {
                    font-size: 1.5rem;
                }
                h3 {
                    font-size: 1rem;
                }
            }
        }
        @media (max-width: 500px) {
            max-height: 155px;
        }
        @media (max-width: 320px) {
            max-height: 450px;
        }   

    }
`